import type { AppSearchAction } from '../../model/types';

export const getSpotlightActionRows = (root: HTMLElement | null) => [
  ...(root?.querySelectorAll<HTMLElement>('[data-action]') ?? []),
];

export const syncSpotlightSelection = (
  root: HTMLElement | null,
  target: HTMLElement,
  index: number,
  setSelected: (index: number) => void,
) => {
  if (target.getAttribute('data-selected') === 'true') {
    return;
  }

  root
    ?.querySelector<HTMLElement>('[data-action][data-selected]')
    ?.removeAttribute('data-selected');
  target.setAttribute('data-selected', 'true');
  setSelected(index);
};

export const selectSpotlightActionAt = (
  root: HTMLElement | null,
  index: number,
  setSelected: (index: number) => void,
) => {
  const target = getSpotlightActionRows(root)[index];
  if (!target) {
    return;
  }

  syncSpotlightSelection(root, target, index, setSelected);
};

export const resolveSpotlightAction = (
  root: HTMLElement | null,
  actions: AppSearchAction[],
  hoveredIndex: number | null,
  ignoreHover = false,
) => {
  const rows = getSpotlightActionRows(root);
  const hoveredRow = ignoreHover
    ? undefined
    : (rows.find((row) => row.matches(':hover')) ??
      (hoveredIndex == null ? undefined : rows[hoveredIndex]));
  const selectedRow = rows.find((row) => row.hasAttribute('data-selected'));
  const row = hoveredRow ?? selectedRow ?? rows[0];
  const index = row ? rows.indexOf(row) : 0;
  const action =
    actions.find((item) => item.id === row?.dataset.searchId) ??
    actions[index] ??
    actions[0];

  return { action, index, row: row ?? null };
};